<template>
	<div class="container-fluid">
    	<div class="row d-flex justify-content-center m-2">
    		<div class="col-12">
    			<div class="row">
    				<div class="col-12">
    					<div class="alert alert-primary">
    						<div class="h4 text-center">
    							<linkto :link="'/managers'"/>
    							Kezelő módosítás
    						</div>
    					</div>
    				</div>
    			</div>
    			<div class="row d-flex justify-content-center align-items-center">
    				<managerdata
    					:change="true"
    					:id="$route.params.id"
    				>
    				</managerdata>
    			</div>
    		</div>
    	</div>
	</div>
</template>

<script>
import moment from 'moment'
import managerdata from './manager_data'
export default {
  name: 'customer',
  components: {
  	managerdata
  },
  data () {
    return {
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/managers/manager.vue